<script lang="ts">
    import RewardsCustomerBalance from "@apps/rewards/components/RewardsCustomerBalance.svelte";
    import RewardsPoints from "@apps/rewards/components/RewardsPoints.svelte";
    import RewardsStoreCredit from "@apps/rewards/components/RewardsStoreCredit.svelte";
    import type RewardsAmountFormatter from "@apps/rewards/lib/RewardsAmountFormatter/RewardsAmountFormatter";
    import type { TranslationNamespaces } from "@apps/rewards/types";
    import { getHumanReadableDate } from "@lib/utils";
    import type { GwI18n } from "@modules/i18n/GwI18n/GwI18n";

    import T from "@components/T.svelte";
    import Text from "@components/Typography/Text.svelte";

    //Props
    export let customerBalance: number | undefined;
    export let pointsExpiration: string | null | undefined;
    export let amountFormatter: RewardsAmountFormatter;
    export let i18n: GwI18n;
    export let namespace: TranslationNamespaces;
    export let pointsNamespace: TranslationNamespaces;
    export let storeCreditBalance: string | null;
    export let isStoreCreditEnabled: boolean;
</script>

<div class="gw-rd-page-widget-customer-balance">
    <Text component="h2" variant="base" weight="semibold">
        <T {namespace} translationKey="customer_balance" />
        <RewardsCustomerBalance let:customerBalance {customerBalance}>
            <RewardsPoints
                points={customerBalance}
                {amountFormatter}
                {i18n}
                {pointsNamespace}
            />
        </RewardsCustomerBalance>
    </Text>
    
    <RewardsStoreCredit
        let:storeCreditBalance
        {isStoreCreditEnabled}
        {storeCreditBalance}
    >
        <Text component="h2" variant="base" weight="semibold">
            <T
                {namespace}
                translationKey="store_credit_balance"
                translationOptions={{
                    balance: storeCreditBalance,
                }}
            />
        </Text>
    </RewardsStoreCredit>
    {#if pointsExpiration}
        <div class="gw-rd-page-widget-customer-balance__points-expiration">
            <Text component="span" variant="base">
                <T
                    {namespace}
                    translationKey="points_expiration"
                    translationOptions={{
                        date: getHumanReadableDate(pointsExpiration),
                    }}
                />
            </Text>
        </div>
    {/if}
</div>

<style lang="postcss">
    .gw-rd-page-widget-customer-balance {
        max-width: 359px;
        width: 100%;
        display: grid;
        gap: var(--gw-rd-space-3);
        padding: var(--gw-rd-space-14) var(--gw-rd-space-7);
        margin: 0 auto;
        background-color: var(--gw-rd-light-skyblue-bg-color);
        border-radius: var(--gw-rd-border-radius-md);
        box-sizing: border-box;
        font-size: clamp(18px, 14px + 0.8vw, 20px);
        color: var(--gw-rd-primary-color);

        &__points-expiration {
            font-size: clamp(14.5px, 11.7px + 0.56vw, 16px);
            color: var(--gw-rd-secondary-color);
        }
    }
</style>
